import React from 'react';

const RightArrowIcon = ({ size = 15, color = '#1D364C' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      className="icon"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      stroke={color}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z"
          fill={color}
        ></path>
      </g>
    </svg>
  );
};

export default RightArrowIcon;
